import React from 'react';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import LegalUser from './LegalUser';
import { connect } from 'react-redux';
import { changeTab } from '../../store/actions/LaywerUserAction';
import './LegalUsersBox.scss';

function LegalUsersBox({
  title,
  list,
  buttonTitle,
  direction,
  maxWidth,
  changeTab,
  typeOfUser
}) {
  const breakpoint = useMediaQuery('(max-width:959px)');

  const handleTab = () => {
    if ((typeOfUser && typeOfUser === 'lawyer') || !typeOfUser) {
      changeTab(0)
    } else if (typeOfUser && typeOfUser === 'lawFirm') {
      changeTab(1)
    }
  }

  return (
    <div className='legalUsers' style={{ maxWidth: maxWidth ? maxWidth : 1152 }}>
      <h3 className='legalUsers_title'>{title}</h3>

      <div className='legalUsers_container'>
        <Grid container spacing={breakpoint ? 3 : 2}>
          {list && list.map((user, index) => 
          <Grid key={index} item xs={12} md={4}>
            {/* <Link to={`/${user.role === 'lawyer' ? 'abogado' : 'despacho'}/${user.uid}`}> */}
              <LegalUser user={user} />
            {/* </Link> */}
          </Grid>
          )}
        </Grid>
      </div>
      <span className='legalUsers_link'>
        <Link onClick={handleTab} to={direction}>
          {buttonTitle}
        </Link>
      </span>
    </div>
  )
}

const mapDispatchToProps = dispatch => ({
  changeTab: tab => dispatch(changeTab(tab))
})

export default connect(null, mapDispatchToProps)(LegalUsersBox);
